import { get } from 'lodash';
import { getStaticsVersionFromUrl } from './statics-version';
import { AppParams, FlowAPI } from '../../app/types/platform-types';
import type { ErrorMonitor } from '@wix/fe-essentials-viewer-platform/error-monitor';
import { PanoramaClientForComponent } from '@wix/panorama-client';

export const ENVIRONMENT = {
  APP: 'App',
  RPW: 'RPW',
};

export const normalizeError = (error: any) => {
  if (
    typeof Response !== 'undefined' &&
    error instanceof Response &&
    error.constructor.name !== 'Error'
  ) {
    return Error(`Failed to fetch ${error.url} with status ${error.status} - ${error.statusText}`);
  }

  if (!error) {
    return new Error('Error is undefined.');
  }

  return error;
};

export const decorateActionsWithLogger = <T extends { [key: string]: any }>(
  actions: T,
  panoramaClient?: PanoramaClientForComponent,
): T => {
  const decoratedActions: any = {};
  const decorate =
    (action: any, key: string) =>
    (...args: any[]) => {
      const captureToErrorMonitor = (e: any) =>
        panoramaClient?.errorMonitor().reportError(normalizeError(e), {
          context: { extra: { action: key } },
          tags: { capturedBy: 'action monitor' },
        });
      try {
        const response = action(...args);
        if (response instanceof Promise) {
          response.catch((error) => {
            if (error && error.status !== 200 && error.status !== 500) {
              return;
            }

            captureToErrorMonitor(error);
          });
        }
        return response;
      } catch (error) {
        captureToErrorMonitor(error);
      }
    };

  Object.keys(actions).forEach((key) => {
    const action = actions[key];
    decoratedActions[key] = decorate(action, key);
  });

  return decoratedActions;
};
